/* Shared owner-approved Broilmaster core PDP review behavior. */
(()=>{
 const mount=()=>{const root=document.querySelector('.fm-page[data-product-handle^="broilmaster-"]');if(!root||root.dataset.broilmasterReviewReady)return;root.dataset.broilmasterReviewReady='true';
 const source=root.querySelector('[data-trueflame-installation-data]');if(source){const data=JSON.parse(source.textContent);for(const src of [data.image,root.querySelector('[data-fm-main]')?.src].filter(Boolean)){const image=new Image();image.src=src;image.decode().catch(()=>{});}}
 const template=document.querySelector('#aog-accordion-chevron');
 const draftPreview=root.dataset.broilmasterDraftPreview==='true';
 if(draftPreview)root.addEventListener('submit',event=>{if(event.target.matches('form[action*="/cart/add"]')){event.preventDefault();event.stopImmediatePropagation();}},true);
 const enhance=()=>{
  if(draftPreview)root.querySelectorAll('.fm-add').forEach(button=>{if(!button.disabled)button.disabled=true;});
  if(template)root.querySelectorAll('details>summary:not([data-broilmaster-chevron])').forEach(summary=>{summary.dataset.broilmasterChevron='true';summary.append(template.content.cloneNode(true));});
  const actions=root.querySelector('.hx27-secondary-actions'),expert=root.querySelector('.fm-buy>a[href="/pages/customer-care#contact"]');
  if(actions&&expert)actions.append(expert);
 };
 enhance();new MutationObserver(enhance).observe(root,{childList:true,subtree:true});
 const videos=new Set();
 const visible=new Set();
 const start=video=>{
  if(!visible.has(video)||document.visibilityState!=='visible')return;
  video.muted=true;video.defaultMuted=true;video.playsInline=true;
  video.play().catch(()=>{});
 };
 const observer=new IntersectionObserver(entries=>{
  for(const entry of entries){
   const video=entry.target;
   if(entry.isIntersecting&&entry.intersectionRatio>0){visible.add(video);start(video);}
   else{visible.delete(video);video.pause();}
  }
 },{threshold:0});
 const register=()=>root.querySelectorAll('video:not([data-native-video-managed])').forEach(video=>{
  if(videos.has(video))return;videos.add(video);
  video.muted=true;video.defaultMuted=true;video.playsInline=true;
  video.setAttribute('muted','');video.setAttribute('playsinline','');
  video.preload='metadata';
  video.addEventListener('loadeddata',()=>start(video));
  video.addEventListener('canplay',()=>start(video));
  observer.observe(video);
 });
 register();new MutationObserver(register).observe(root,{childList:true,subtree:true});
 document.addEventListener('visibilitychange',()=>{
  for(const video of videos){if(document.hidden)video.pause();else start(video);}
 });
};mount();document.addEventListener('hx27:model-ready',mount);document.addEventListener('hearth:pdp-prepared',mount);})();
